import axios from 'axios'
import config from '../../config/index'

// 客服下拉列表
export function queryCustomerList (datas) {
  const url = `/noteInfo/queryCustomerList`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 客服统计列表
export function iMCustomerStatistics (datas) {
  const url = `/iMCustomerStatistics`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 客服统计导出
export function exportCustomerStatisticsList (datas) {
  const url = `/iMCustomerStatistics/exportCustomerStatisticsList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取当前客服情况
export function queryCurrentCustomerStatus (datas) {
  const url = `/iMCustomerStatistics/queryCurrentCustomerStatus`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取当前客服情况列表
export function queryCurrentCustomerStatusList (datas) {
  const url = `/iMCustomerStatistics/queryCurrentCustomerStatusList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取接待量总览图表
export function queryCustomerReceptionOverview (datas) {
  const url = `/iMCustomerStatistics/queryCustomerReceptionOverview`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取一类问题饼图
export function queryLevelOneProblem (datas) {
  const url = `/iMCustomerStatistics/queryLevelOneProblem`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 根据一类问题加载二类问题工单数柱状图
export function queryLevelTwoProblem (datas) {
  const url = `/iMCustomerStatistics/queryLevelTwoProblem`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取接待量总览图表导出
export function exportCustomerReceptionOverview (datas) {
  const url = `/iMCustomerStatistics/exportCustomerReceptionOverview`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取一类问题饼图导出
export function exportLevelOneProblem (datas) {
  const url = `/iMCustomerStatistics/exportLevelOneProblem`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 根据一类问题加载二类问题工单数柱状图导出
export function exportLevelTwoProblem (datas) {
  const url = `/iMCustomerStatistics/exportLevelTwoProblem`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取客服服务质量列表
export function queryCustomerServiceQualityList (datas) {
  const url = `/iMCustomerStatistics/queryCustomerServiceQualityList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 导出客服服务质量列表
export function exportCustomerServiceQualityList (datas) {
  const url = `/iMCustomerStatistics/exportCustomerServiceQualityList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 查看历史记录（旧 网易云信）
export function queryMsgHistoryRcordList (datas) {
  const url = `/iMCustomerStatistics/queryMsgHistoryRcordList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 查看历史记录（新 腾讯云）
export function queryChatHistoryRecord (datas) {
  const url = `${config.im_url}/tencentCloudIM/queryChatHistoryRecord`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取用户评价列表
export function queryUserEvaluatelList (datas) {
  const url = `/iMCustomerStatistics/queryUserEvaluatelList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 导出用户评价列表
export function exportUserEvaluatelList (datas) {
  const url = `/iMCustomerStatistics/exportUserEvaluatelList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 机器人问答统计
export function queryProblemHelpRecordSumCount (datas) {
  const url = `/problemHelpRecord/queryProblemHelpRecordSumCount`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 机器人问答评价列表
export function queryProblemHelpRecordCountPage (datas) {
  const url = `/problemHelpRecord/queryProblemHelpRecordCountPage`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 关键词搜索统计列表导出
export function exportProblemHelpRecordCountList (datas) {
  const url = `/problemHelpRecord/exportProblemHelpRecordCountList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 关键词搜索统计列表
export function queryTalkProblemRecordCountPage (datas) {
  const url = `/talkProblemRecord/queryTalkProblemRecordCountPage`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 关键词搜索统计列表导出
export function exportTalkProblemRecordCountList (datas) {
  const url = `/talkProblemRecord/exportTalkProblemRecordCountList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取分时咨询列表
export function queryLoginLogoutRecordCountList (datas) {
  const url = `/loginLogoutRecord/queryLoginLogoutRecordCountList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 分时咨询列表导出
export function loginLogoutRecordCountListExport (datas) {
  const url = `/loginLogoutRecord/loginLogoutRecordCountListExport`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 客服访问日志列表
export function queryCustomerAccessRecord (datas) {
  const url = `/iMCustomerStatistics/queryCustomerAccessRecord`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 客服访问日志列表导出
export function exportCustomerAccessRecord (datas) {
  const url = `/iMCustomerStatistics/exportCustomerAccessRecord`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/statistics/index.js